// extracted by mini-css-extract-plugin
export default {"paper":"styles__paper___AwosM","banner":"styles__banner___yC3NG","innerWrapper":"styles__innerWrapper___T4Tf2"};